import { FaIcon, ThemeTokens } from '@acp/core-ui';
import {
    Button, Menu, MenuButton, MenuList, Text,
} from '@chakra-ui/react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import React from 'react';

export function ResponsiveNavigationMenu({
    label,
    children,
}: {
    label: string;
    children: React.ReactNode;
}) {
    return (
        <Menu>
            <MenuButton
                as={Button}
                variant="link"
                size="sm"
                rightIcon={(
                    <FaIcon icon={faChevronDown} size="xs" />
                )}
                color="black"
                h="100%"
                px={0}
                fontWeight="bold"
                _active={{
                    color: 'black',
                    _before: {
                        content: '""',
                        h: '2px',
                        position: 'absolute',
                        w: '100%',
                        bgColor: ThemeTokens.AppNavigation.accentColor,
                        bottom: 0,
                    },
                }}
                _hover={{
                    color: 'black',
                    _before: {
                        content: '""',
                        h: '2px',
                        position: 'absolute',
                        w: '100%',
                        bgColor: ThemeTokens.AppNavigation.accentColor,
                        bottom: 0,
                    },
                }}
            >
                <Text noOfLines={1}>
                    {label}
                </Text>
            </MenuButton>
            <MenuList>{children}</MenuList>
        </Menu>
    );
}
